module.exports = __webpack_public_path__ + "static/media/Disburse-Virtual_MC_Disclosure_Short Form_Equifax.61ad1923.pdf";